export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "妖精漫画堂收录哪些题材的韩国妖精漫画？",
    a: "我们专注韩国妖精漫画的奇幻魔法、异世界穿越、精灵契约与妖怪神话题材，所有作品均围绕精灵、妖怪、神祇与魔法世界展开，按世界观划分为三大分类，方便你按喜好快速浏览。",
  },
  {
    q: "为什么我找不到某一部具体的漫画？",
    a: "我们的收录范围集中在妖精、精灵、妖怪与神话题材的作品。如果你在搜索时找不到目标作品，可以尝试使用分类筛选或切换关键词，也可以前往联系我们页面提交推荐，我们会评估后补充进片单。",
  },
  {
    q: "作品简介与更新信息会同步更新吗？",
    a: "会的。我们会定期核对热门作品的连载状态、章节数与简介，确保你看到的分类与故事简介尽量贴近最新情况。具体章节进度仍建议以官方连载平台为准。",
  },
  {
    q: "网站上的内容可以免费阅读吗？",
    a: "妖精漫画堂是一个漫画资讯与推荐平台，提供分类浏览、作品简介与剧情导读。在线阅读请通过页面提供的官方渠道进行，我们尊重并支持创作者的正版权益。",
  },
  {
    q: "我追的作品停更了，如何知道它是否完结？",
    a: "你可以在作品详情页查看标注的连载状态与章节数，或关注该分类的更新速览。若作品已标注『已完结』，即可直接一次性追完；连载中作品请留意官方平台的最新动向。",
  },
  {
    q: "如何反馈问题或推荐新作品？",
    a: "欢迎通过联系我们页面的表单告诉我们。无论是发现内容有误，还是想推荐你喜爱的妖精漫画，我们都会认真阅读每一条反馈并尽快处理。",
  },
];